export const AuthMethods = {
  Spain: 'SPAIN',
  FranceMock: 'FRANCE_MOCK'
} as const;

export type AuthMethods = (typeof AuthMethods)[keyof typeof AuthMethods];

export interface SpainAuthResponse {
  userId: string;
  displayName: string;
  username: string;
}
